import React from "react";
import { Reveal, Overline } from "@/components/site/Reveal";

export default function DreamTimeline() {
  return (
    <section className="relative overflow-hidden bg-white pb-16 pt-10 md:py-24" data-testid="timeline-section">
      <div className="mx-auto max-w-4xl px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <Overline className="text-sun">Promoção 2 por 1</Overline>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[1.04] tracking-tight text-brand-navy sm:text-5xl">
            Na compra de um ingresso você ganha outro
          </h2>
          <p className="mt-4 font-accent text-2xl text-ocean-mid sm:text-3xl">
            Ao finalizar a compra você recebe nossa agenda virtual diretamente no seu WhatsApp e e-mail para escolher a melhor data.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
